import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-739efefb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "careersheet_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "careersheet_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_title_text" }, "学歴の編集")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "careersheet_education_text" }, "最終学歴からご入力ください", -1))
const _hoisted_4 = { class: "careersheet_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "卒業区分"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_6 = { class: "careersheet_input_layout_column_2" }
const _hoisted_7 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_8 = { class: "careersheet_input_layout_column_2_item" }
const _hoisted_9 = { class: "careersheet_education_title" }
const _hoisted_10 = { class: "careersheet_education_title_text" }
const _hoisted_11 = { class: "careersheet_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "学校情報"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_13 = { class: "careersheet_input_layout_column_1" }
const _hoisted_14 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_15 = { class: "careersheet_input_layout_column_1" }
const _hoisted_16 = { class: "careersheet_input_layout_column_1_item" }
const _hoisted_17 = { class: "careersheet_input" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "入学年月"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_19 = { class: "careersheet_input_layout_column_2" }
const _hoisted_20 = { class: "careersheet_input" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "卒業年月"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_22 = { class: "careersheet_input_layout_column_2" }
const _hoisted_23 = {
  key: 0,
  class: "careersheet_education_delete"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "careersheet_education_add" }
const _hoisted_26 = { class: "careersheet_button" }
const _hoisted_27 = { class: "careersheet_button_prev" }
const _hoisted_28 = { class: "careersheet_button_next" }

import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseYmForm from '@/components/BaseYmForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import { Ref, computed } from 'vue';
import store from '@/store';
import { useField, useForm, useFieldArray } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';
import { object, string, array, number } from 'yup';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import { EducationItem, SchoolHistoryInfoItem } from '@/types';
import { useRouter, useRoute } from 'vue-router';
import alertOnReload from '@/utils/alertOnReload';

export default /*#__PURE__*/_defineComponent({
  __name: 'EducationEditView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const schema = object({
  education: array()
    .of(
      object().shape({
        schlname: string().label('学校名').required(VALIDATON_ERRORS.REQUIRED).max(70, VALIDATON_ERRORS.MAX_LENGTH),
        schldeptname: string().label('学部名').max(35, VALIDATON_ERRORS.MAX_LENGTH),
        entranceYm: string().label('入学年月').required(VALIDATON_ERRORS.REQUIRED),
        entranceFlg: number().nullable().label('入学/編入').required(VALIDATON_ERRORS.REQUIRED),
        gradYm: string().label('卒業年月').required(VALIDATON_ERRORS.REQUIRED),
        gradFlg: number().nullable().label('卒業/中退').required(VALIDATON_ERRORS.REQUIRED),
      })
    )
    .strict(),
});

const { meta, errors } = useForm({
  validationSchema: schema,
});

const schlErrors = (index: number, formName: string) => {
  const error = errors.value[`education[${index}].${formName}`];
  return error !== undefined ? [error] : [];
};

const {
  remove: educationRemove,
  replace: educationReplace,
  push: educationPush,
  fields: education,
} = useFieldArray<EducationItem>('education');

const mstListLstSchlOptions: Ref<Options> = computed(() => store.getters['master/mstListLstSchlOptions']);
const mstListEntranceOptions: Ref<Options> = computed(() => store.getters['master/mstListEntranceOptions']);
const mstListGradOptions: Ref<Options> = computed(() => store.getters['master/mstListGradOptions']);

const { value: lstschlId, errors: lstschlIdErrors } = useField<number | null>('lstschlId', validationRuleHelper({ required: true }), {
  initialValue: store.getters['careerSheetEducation/lstschlId'],
  bails: false,
  label: '卒業区分',
});

const { value: scienceFlg, errors: scienceFlgErrors } = useField<boolean>('scienceFlg', undefined, {
  initialValue: store.getters['careerSheetEducation/scienceFlg'],
  bails: false,
  label: '理系',
});

const lstschlErrors = computed(() => {
  if (lstschlIdErrors.value.length > 0) return lstschlIdErrors.value;
  return scienceFlgErrors.value;
});

const schoolHistoryInfoList: SchoolHistoryInfoItem[] = store.getters['careerSheetEducation/schoolHistoryInfoList'];

let index = 0;
const defaultEducationItem: EducationItem = {
  index,
  schlname: '',
  schldeptname: '',
  entranceYm: '',
  entranceFlg: null,
  gradYm: '',
  gradFlg: null,
};
const init = () => {
  if (schoolHistoryInfoList.length < 1) {
    index++;
    educationPush({ ...defaultEducationItem, index });
  } else {
    const education = schoolHistoryInfoList
      .map((item) => {
        index++;
        return {
          index,
          schlname: item.schlname || '',
          schldeptname: item.schldeptname || '',
          entranceYm: `${item.entranceyr}-${String(item.entrancemon).padStart(2, '0')}`,
          entranceFlg: item.entranceFlg,
          gradYm: `${item.gradyr}-${String(item.gradmon).padStart(2, '0')}`,
          gradFlg: item.gradFlg,
        };
      })
      .filter((i) => i.index <= 4);
    educationReplace(education);
  }
};

init();

const deleteEducation = (id: number) => {
  if (education.value.length <= 1) {
    return;
  }

  const index = education.value.findIndex((i) => i.value.index === id);
  if (index > -1) {
    delete errors.value[`education[${index}].entranceFlg`];
    delete errors.value[`education[${index}].entranceYm`];
    delete errors.value[`education[${index}].gradFlg`];
    delete errors.value[`education[${index}].gradYm`];
    delete errors.value[`education[${index}].schldeptname`];
    delete errors.value[`education[${index}].schlname`];
    educationRemove(index);
  }
};

const addEducation = () => {
  meta.value.dirty = false;
  index++;
  educationPush({ ...defaultEducationItem, index });
};

const isAddDisabled = computed(() => {
  return education.value.length >= 4;
});

const newSchoolHistoryInfoList: Ref<SchoolHistoryInfoItem[]> = computed(() => {
  return education.value.map((item) => {
    return {
      schlname: item.value.schlname,
      schldeptname: item.value.schldeptname,
      entranceyr: item.value.entranceYm.split('-')[0] || '',
      entrancemon: item.value.entranceYm.split('-')[1] || '',
      entranceFlg: item.value.entranceFlg,
      gradyr: item.value.gradYm.split('-')[0] || '',
      gradmon: item.value.gradYm.split('-')[1] || '',
      gradFlg: item.value.gradFlg,
    };
  });
});

const isSchoolHistoryError = computed(() => {
  return newSchoolHistoryInfoList.value.some((i) => {
    return !i.entranceFlg || !i.entrancemon || !i.entranceyr || !i.gradFlg || !i.gradmon || !i.gradyr || !i.schlname;
  });
});

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e50', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n50' });
  }
};

const transitionConfirmPage = () => {
  const param = {
    lstschlId: lstschlId.value,
    scienceFlg: scienceFlg.value,
    schoolHistoryInfoList: newSchoolHistoryInfoList.value,
  };
  store.commit('careerSheetEducation/set', param);
  if (route.query.ref === 'e') {
    router.push({ name: 'e52', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e52' });
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BaseSelectBox, {
            placeholder: "卒業区分を選択",
            options: _unref(mstListLstSchlOptions),
            modelValue: _unref(lstschlId),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(lstschlId) ? (lstschlId).value = $event : null))
          }, null, 8, ["options", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseCheckbox, {
            value: true,
            modelValue: _unref(scienceFlg),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(scienceFlg) ? (scienceFlg).value = $event : null)),
            label: "理系"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(lstschlErrors) }, null, 8, ["errors"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(education), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.value.index
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h2", _hoisted_10, "学歴" + _toDisplayString(index + 1), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(BaseTextForm, {
                placeholder: "学校名",
                modelValue: item.value.schlname,
                "onUpdate:modelValue": ($event: any) => ((item.value.schlname) = $event),
                maxlength: 70,
                isError: schlErrors(index, 'schlname').length > 0
              }, null, 8, ["modelValue", "onUpdate:modelValue", "isError"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(BaseTextForm, {
                placeholder: "学部名",
                modelValue: item.value.schldeptname,
                "onUpdate:modelValue": ($event: any) => ((item.value.schldeptname) = $event),
                maxlength: 35,
                isError: schlErrors(index, 'schldeptname').length > 0
              }, null, 8, ["modelValue", "onUpdate:modelValue", "isError"])
            ])
          ])
        ]),
        _createVNode(ErrorMessage, {
          errors: schlErrors(index, 'schlname')
        }, null, 8, ["errors"]),
        _createVNode(ErrorMessage, {
          errors: schlErrors(index, 'schldeptname')
        }, null, 8, ["errors"]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(BaseYmForm, {
            modelValue: item.value.entranceYm,
            "onUpdate:modelValue": ($event: any) => ((item.value.entranceYm) = $event),
            yearSort: "desc"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mstListEntranceOptions), (mstListEntranceOption) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "careersheet_input_layout_column_2_item",
                key: mstListEntranceOption.label
              }, [
                _createVNode(BaseRadioButton, {
                  label: mstListEntranceOption.label,
                  name: `entrance${item.value.index}`,
                  value: mstListEntranceOption.value,
                  modelValue: item.value.entranceFlg,
                  "onUpdate:modelValue": ($event: any) => ((item.value.entranceFlg) = $event)
                }, null, 8, ["label", "name", "value", "modelValue", "onUpdate:modelValue"])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(ErrorMessage, {
          errors: schlErrors(index, 'entranceYm')
        }, null, 8, ["errors"]),
        _createVNode(ErrorMessage, {
          errors: schlErrors(index, 'entranceFlg')
        }, null, 8, ["errors"]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(BaseYmForm, {
            modelValue: item.value.gradYm,
            "onUpdate:modelValue": ($event: any) => ((item.value.gradYm) = $event),
            yearSort: "desc"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mstListGradOptions), (mstListGradOption) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "careersheet_input_layout_column_2_item",
                key: mstListGradOption.label
              }, [
                _createVNode(BaseRadioButton, {
                  label: mstListGradOption.label,
                  name: `grad${item.value.index}`,
                  value: mstListGradOption.value,
                  modelValue: item.value.gradFlg,
                  "onUpdate:modelValue": ($event: any) => ((item.value.gradFlg) = $event)
                }, null, 8, ["label", "name", "value", "modelValue", "onUpdate:modelValue"])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(ErrorMessage, {
          errors: schlErrors(index, 'gradYm')
        }, null, 8, ["errors"]),
        _createVNode(ErrorMessage, {
          errors: schlErrors(index, 'gradFlg')
        }, null, 8, ["errors"]),
        (index > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("button", {
                class: "button_education_delete",
                onClick: ($event: any) => (deleteEducation(item.value.index))
              }, "学歴" + _toDisplayString(index + 1) + "を削除", 9, _hoisted_24)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(BaseButton, {
        theme: "secondary",
        type: "button",
        onClick: addEducation,
        disabled: _unref(isAddDisabled)
      }, {
        default: _withCtx(() => [
          _createTextVNode("＋学歴を追加する（4つまで）")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(BaseButton, {
          theme: "tertiary",
          type: "button",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(BaseButton, {
          theme: "primary",
          type: "button",
          disabled: _unref(isSchoolHistoryError) || _unref(lstschlErrors).length > 0,
          onClick: transitionConfirmPage
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 確認する ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})